// $(document).on("click", ".link_to_page", (e) => {
// 	let el = e.currentTarget;
	
// 	let title = $(el).data("title")
// 	let is_public = $(el).data("is_public")
// 	let is_link = $(el).data("is_link")

// 	if(is_link) {
// 		frappe.set_route("List", title)
// 		return;
// 	}

// 	let url = "/app/" 
// 	url += is_public ? frappe.router.slug(title): "private/" + frappe.router.slug(title)

// 	frappe.set_route(url)
// })
$(document).on("click", ".link_to_page", (e) => {
    if (e.ctrlKey || e.metaKey || e.which === 2) {
        return;
    }

    e.preventDefault();

    $(".link_to_page.active").removeClass("active")

    let el = e.currentTarget;
    $(el).addClass("active")
    
    let title = $(el).data("title");

    let is_public = String($(el).data("is_public")) === "1";
    let is_link   = String($(el).data("is_link")) === "1";

    let url = "/app/" + frappe.router.slug(title);
    if (!is_public) {
        url = "/app/private/" + frappe.router.slug(title);
    }

    $(el).attr("href", url);

    if (is_link) {
        frappe.set_route("List", title);
    } else {
        frappe.set_route(url);
    }
});


$(document).on("click", function(event) {
    $(".side-menu").first().removeClass("side-menu--mobile-menu-open");
    $(".close-mobile-menu").first().removeClass("close-mobile-menu--mobile-menu-open");
});

$(document).on("click", ".side-menu a", function () {
    $(".side-menu").removeClass("side-menu--mobile-menu-open");
    $(".close-mobile-menu").removeClass("close-mobile-menu--mobile-menu-open");
});

// Safely attach router change handler only if frappe.router exists
if (frappe.router && typeof frappe.router.on === 'function') {
    frappe.router.on('change', () => {
        $(".side-menu").removeClass("side-menu--mobile-menu-open");
        $(".close-mobile-menu").removeClass("close-mobile-menu--mobile-menu-open");
    });
}

//sidebar hide logic 
function apply_global_sidebar_control() {
	const is_enabled = localStorage.getItem("sidebar_content");

	const el = document.querySelector(".toggle-compact-menu");

	if (!el) return;

	if (is_enabled === "1") {
		localStorage.setItem("compactMenu", "false");
		localStorage.setItem("forceCompactMenuFalse", "true");

		el.classList.add("force-hide");
	} else {
		el.classList.remove("force-hide");
		localStorage.removeItem("forceCompactMenuFalse");
	}
}

// Safely call apply_global_sidebar_control after AJAX requests
if (frappe.after_ajax && typeof frappe.after_ajax === 'function') {
	frappe.after_ajax(() => {
		apply_global_sidebar_control();
	});
} else if (frappe.call && typeof frappe.call === 'function') {
	// Fallback: Use frappe.call's global ajax complete handler
	$(document).ajaxComplete(() => {
		apply_global_sidebar_control();
	});
} else {
	// Final fallback: Just call it after a short delay
	setTimeout(apply_global_sidebar_control, 100);
}

// Safely attach router change handler
if (frappe.router && typeof frappe.router.on === 'function') {
	frappe.router.on("change", () => {
		setTimeout(apply_global_sidebar_control, 300);
	});
}

document.addEventListener("DOMContentLoaded", () => {
	setTimeout(apply_global_sidebar_control, 500);
});
window.apply_global_sidebar_control = function () {
	const is_enabled = localStorage.getItem("sidebar_content");

	const el = document.querySelector(".toggle-compact-menu");

	if (!el) return;

	if (is_enabled === "1") {
		el.classList.add("force-hide");
	} else {
		el.classList.remove("force-hide");
	}
};

//sidebar expand logic open and close

document.addEventListener("DOMContentLoaded", function () {
    const fullscreenBtn = document.querySelector(".request-full-screen");
    if (fullscreenBtn) {
        fullscreenBtn.addEventListener("click", async function () {
            try {
                if (!document.fullscreenElement) {
                    if (document.documentElement.requestFullscreen) {
                        await document.documentElement.requestFullscreen();
                    } else if (document.documentElement.webkitRequestFullscreen) {
                        await document.documentElement.webkitRequestFullscreen();
                    } else if (document.documentElement.msRequestFullscreen) {
                        await document.documentElement.msRequestFullscreen();
                    }
                } else {
                    if (document.exitFullscreen) {
                        await document.exitFullscreen();
                    } else if (document.webkitExitFullscreen) {
                        await document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) {
                        await document.msExitFullscreen();
                    }
                }
            } catch (error) {
                console.warn("Fullscreen API failed:", error.message);
            }
        });
    }
    const headerSelector = '.fixed.top-0.inset-x-0';
    function updateHeader() {
        const header = document.querySelector(headerSelector);
        const sidebar =
            document.querySelector('.form-sidebar.overlay-sidebar') ||
            document.querySelector('.list-sidebar.overlay-sidebar');
        if (!header || !sidebar) return;
        const isOpen = sidebar.classList.contains('opened');
        if (isOpen) {
            header.style.display = 'none';
        } else {
            header.style.display = 'flex';
        }
    }
    updateHeader();
    const observer = new MutationObserver(updateHeader);
    observer.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true
    });
    window.addEventListener("resize", updateHeader);
    document.addEventListener("click", () => {
        setTimeout(updateHeader, 100);
    });
});
/* // Hide empty dropdowns in action buttons */
// (function () {
//     function hasRealItems(menu) {
//         return [...menu.children].some(li => {
//             if (li.classList.contains('dropdown-divider')) return false;
//             return li.querySelector('.dropdown-item');
//         });
//     }
//     function toggleMenuButtons() {
//         document.querySelectorAll(".menu-btn-group").forEach(group => {
//             const menu = group.querySelector(".dropdown-menu");
//             if (!menu) return;

//             if (hasRealItems(menu)) {
//                 group.style.display = "";
//             } else {
//                 group.style.display = "none";
//             }
//         });
//     }
//     document.addEventListener("DOMContentLoaded", toggleMenuButtons);
//     if (window.frappe) {
//         frappe.after_ajax(() => {
//             toggleMenuButtons();
//         });
//     }
//     const observer = new MutationObserver(() => {
//         toggleMenuButtons();
//     });
//     observer.observe(document.body, {
//         childList: true,
//         subtree: true
//     });
// })();